// import React from 'react';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import { Pagination } from 'swiper/modules';
// import IconBox from '../IconBox';

// export default function ServiceSlider({ data }) {
//   return (
//     <>
//       <Swiper
//         slidesPerView={1}
//         spaceBetween={24}
//         speed={800}
//         pagination={{
//           clickable: true,
//         }}
//         modules={[Pagination]}
//         breakpoints={{
//           500: {
//             slidesPerView: 2,
//             spaceBetween: 15,
//           },
//           991: {
//             slidesPerView: 3,
//           },
//           1750: {
//             slidesPerView: 4,
//           },
//         }}
//       >
//         {data?.map((item, index) => (
//           <SwiperSlide key={index}>
//             <IconBox {...item} shapeClass={`cs_shape_${index + 1}`} />
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </>
//   );
// }


//-----------------------

import React, { useRef, useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import { useInView } from 'react-intersection-observer';
import IconBox from '../IconBox';
import 'swiper/css';
import 'swiper/css/pagination';

export default function ServiceSlider({ data }) {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.3,
  });

  const swiperRef = useRef(null);

  useEffect(() => {
    if (inView && swiperRef.current) {
      swiperRef.current.autoplay.start(); // Start autoplay when in view
    }
  }, [inView]);

  return (
    <div ref={ref}>
      <Swiper
        onSwiper={(swiper) => {
          swiperRef.current = swiper;
          swiper.autoplay.stop(); // Stop autoplay initially
        }}
        slidesPerView={1}
        spaceBetween={24}
        speed={800}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        modules={[Pagination, Autoplay]}
        breakpoints={{
          500: {
            slidesPerView: 2,
            spaceBetween: 15,
          },
          991: {
            slidesPerView: 3,
          },
          1750: {
            slidesPerView: 4,
          },
        }}
      >
        {data?.map((item, index) => (
          <SwiperSlide key={index}>
            <IconBox {...item} shapeClass={`cs_shape_${index + 1}`} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

